import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './app/store';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Suspense } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { disableCache, enableCache, addAPIProvider } from '@iconify/react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
import OperationFeedbackListener from './components/operation-feedback-listener';

// Import icon registry to register all local icons
import './components/iconify/icon-registry';

// Fonts
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fontsource/public-sans/800.css';
import '@fontsource/public-sans/900.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';

// Configure Iconify to use only local icons, disable all API calls
disableCache('all');
enableCache('local');

// Disable all external API providers to prevent web requests
// This ensures icons are only loaded from locally registered icons
addAPIProvider('', {
  resources: [],
});

const oidcConfig = {
  authority: process.env.REACT_APP_KEYCLOAK_URL,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENTID,
  redirect_uri: process.env.REACT_APP_BASE_URL,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
    window.location.reload();
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <AuthProvider {...oidcConfig}>
          <Provider store={store}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <SnackbarProvider maxSnack={5} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <OperationFeedbackListener />
                <App />
              </SnackbarProvider>
            </LocalizationProvider>
          </Provider>
        </AuthProvider>
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>,
);
